import { HTMLAttributes } from 'react';
import { cn } from '../utils';

export const Highlight = ({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLSpanElement>) => (
  <span className={cn('text-foreground font-bold', className)} {...props}>
    {children}
  </span>
);
